
import { Component, EventEmitter, Output , OnInit, SimpleChanges, ViewChild, ElementRef, Input, OnDestroy, OnChanges} from '@angular/core';
import { contenidosModuleRoutes } from '../../modules/contenidos.module';
import { EntityManagerProvider } from '../../providers/entity-manager-provider/entity-manager-provider';
import { SortEvent } from './draggable/sortable-list.directive';
import { Foto } from '../../domain/Foto';


@Component({
  selector: 'app-carrousel-fotos',
  templateUrl: './carrouselFotos.component.html',
  styleUrls: ['./carrouselFotos.component.scss']
})


export class CarrouselFotosComponent implements OnInit, OnChanges {


	public subidaFoto: boolean; 
	  @ViewChild('fileUploader') fileUploader:ElementRef;
	  @Input() fotos: Foto[] = [];
	  @Output() nuevoCarrusel = new EventEmitter<Foto[]>();

	constructor(
		private entityManager: EntityManagerProvider
		)
	{
		this.subidaFoto = true;

	}

	ngOnInit(): void {
		this.subidaFoto = true;
	}
	ngOnChanges(change) {

		if (change.fotos) {
			this.fotos = change.fotos.currentValue;
			this.subidaFoto = false;
			this.fotos = this.ordenarCarrusel(this.fotos);
		}

	}

	ordenarCarrusel(fotos){
		fotos.sort(function (a, b) {
			if (a.Orden > b.Orden) {
			  return 1;
			}
			if (a.Orden < b.Orden) {
			  return -1;
			}
			// a must be equal to b
			return 0;
		  });
		  return fotos;
	}


	 sort(event: SortEvent) {
	 	const current = this.fotos[event.currentIndex];
	 	const swapWith = this.fotos[event.newIndex];
	
	 	this.fotos[event.newIndex] = current;
	 	this.fotos[event.currentIndex] = swapWith;
		this.fotos[event.newIndex].Orden = event.newIndex;
		this.fotos[event.currentIndex].Orden = event.currentIndex;
		this.nuevoCarrusel.emit(this.fotos)
		
	   }
	   eliminarFoto(foto: any){
	 	let nuevoArray = this.fotos.filter((item) => item !== foto)
	 	this.fotos = nuevoArray;
		this.nuevoCarrusel.emit(this.fotos)
	   }

	   subirFotoCarrusel(event){
	 	this.subidaFoto = true;
	 	const that = this;

	 	const file: File = event.target.files[0];
		let foto = new Foto();
		foto.File = file;
		foto.Orden = this.fotos.length;
		foto.Tipo = 1;
		foto.Id = 'undefined';
	 	if (FileReader && file) {
		const fr = new FileReader();
		 		fr.onload = e => {
		 			//this.srcNuevaImagenDetalle =  <string>e.target.result
					 foto.UrlFotoExt = <string>e.target.result;
	 				this.fotos.push(foto);
				 	this.nuevoCarrusel.emit(this.fotos)
				 	this.subidaFoto = false;
	 			
				
	 		};
	 		fr.readAsDataURL(file);
	 	}
	 	this.fileUploader.nativeElement.value = null;


	 }




}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/componentes/carrouselFotos/carrouselFotos.component.ts